export default __webpack_public_path__ + "static/media/Next.fb6732e6.svg";